import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated: boolean = localStorage.getItem('is_loggedIn') === 'true';

  if (!isAuthenticated) {

    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;